import React from 'react'
import styles from './style.module.scss'
import PropTypes from 'prop-types'
import olympicsMascot from 'assets/images/olympics/olympicsMascot.png'
import MyImage from '@shared/components/myImage'
import { OlympicsLogoBig, OlympicsLogoBigMweb, PointerRight } from '@shared/components/ctIcons'
import CustomLink from '@shared/components/customLink'
import CountdownTimer from '../timer'
import useWindowSize from '@shared/hooks/windowSize'

export default function OlympicsHeader() {
  const [width] = useWindowSize()

  if (width > 950) {
    return (
      <div className={styles.borderBtm}>
        <div className="container">
          <div className={`${styles.olympicsHeader} ${styles.olympicsHeaderBg} d-flex`}>
            <div className={`${styles.titleCntr} d-flex`}>
              <MyImage src={olympicsMascot} alt="Olympics Mascot" width={120} height={101} />
              <div className={`${styles.titleMascot} d-flex flex-column justify-content-center`}>
                <div className={styles.titleMascotH}>
                  PARIS 2024 <br />
                  THE MASCOT
                </div>
                <CustomLink href={'https://www.oneturf.news/olympics/all-about-2024-summer-olympics-mascot-6349'} className="mr-1">
                  <div className={styles.titleMascotLink}>
                    <a>View More</a>
                    <span className="ms-2">
                      <PointerRight />
                    </span>
                  </div>
                </CustomLink>
              </div>
            </div>
            <div className={styles.title}>
              <div className={styles.titleText}>
                <div className={styles.titleMain}>Olympic Games Paris 2024</div>
                <div className={styles.titleSub}>26 July - 11 August, 2024</div>
              </div>
              <OlympicsLogoBig />
            </div>
            <div className="d-flex justify-content-center">
              <CountdownTimer />
            </div>
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div className={`${styles.olympicsHeaderMWeb} ${styles.mWeb}`}>
        <div className={styles.title}>
          <div className={styles.titleText}>
            <div className={styles.titleMain}>Olympic Games Paris 2024</div>
            <div className={styles.titleSub}>26 July - 11 August, 2024</div>
          </div>
          <OlympicsLogoBigMweb />
        </div>
        <div className={`${styles.titleCntr}`}>
          <div className="d-flex justify-content-center">
            <CountdownTimer isMweb />
          </div>
          <div className={`d-flex align-items-end justify-content-around ${styles.background}`}>
            <div className={`${styles.titleMascot} d-flex flex-column justify-content-center`}>
              <div className={styles.titleMascotH}>THE MASCOT</div>
            </div>
            <MyImage src={olympicsMascot} width={120} height={101} />
            <CustomLink href={'https://www.oneturf.news/olympics/all-about-2024-summer-olympics-mascot-6349'} className="mr-1">
              <div className={styles.titleMascotLink}>
                <a>View More</a>
                <span className="ms-2">
                  <PointerRight />
                </span>
              </div>
            </CustomLink>
          </div>
        </div>
      </div>
      // <div>ssss</div>
    )
  }
}
OlympicsHeader.propTypes = {
  data: PropTypes.any
}
